import { useAuth0 } from "@auth0/auth0-react";
import styles from "./addemailcampaign.module.css"
import { ArrowLeft, Home, X } from "react-feather";
import { FormControl, IconButton, InputLabel, MenuItem, Select, Slide, Snackbar, TextField, Typography } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useEffect, useRef, useState } from "react";
import Loader from "../../../../components/Loader";
import { Editor } from "@tinymce/tinymce-react";
import Footer from "../../../../components/Footer";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import withCustomAuthenticationRequired from "../../../../auth/withCustomAuthenticationRequired";

const schema = yup.object().shape({
    title: yup.string().required("This field is Required").max(200, "Layout title can not be more than 100 characters"),
    description: yup.string().required("This field is Required")
});

const AddCampaign = ({ history, match }) => {
    const { getAccessTokenSilently } = useAuth0();
    const redirect = useHistory();
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const { id } = match.params;
    const isAddMode = !id;
    const editorRef = useRef(null);

    const { errors, control, handleSubmit, setValue } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            title: '',
            logo_type: ''
        }
    });

    useEffect(() => {
        async function fetchData() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios.get(process.env.REACT_APP_USER_API_URL + "v1/campaign/email-templates/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                setValue("title", response.data.data?.title);
                setValue("description", response.data.data?.description);

                if (response.data.data?.logo_type) {
                    if (response.data.data?.logo_type !== '') {
                        setValue("logo_type", response.data.data?.logo_type);
                    }
                }
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        }

        if (id) {
            fetchData();
        }
    }, [id, getAccessTokenSilently, setValue]);

    const onSubmit = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        if (data?.logo_type === '')
            delete data?.logo_type;

        axios.post(process.env.REACT_APP_USER_API_URL + "v1/campaign/email-templates", data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarMsg("Email Templates added successfully.");
            setSnackbarOpen(true);

            setTimeout(() => {
                redirect.push('/communication/campaigns');
            }, 2000);

        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        if (data?.logo_type === '')
            delete data?.logo_type;


        axios.post(process.env.REACT_APP_USER_API_URL + "v1/campaign/email-templates/" + id, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarMsg("Email Templates updated successfully.");
            setSnackbarOpen(true);

            setTimeout(() => {
                redirect.push('/communication/campaigns');
            }, 2000);

        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<>
        {loading && <Loader />}
        <Helmet title={isAddMode ? "Add Email Template" : "Edit Email Template"} />

        <div className={`${styles.mainCard}`}>
            <div className={`${styles.SMProCusRow}`}>
                <div className={`${styles.BreadcrumbHeadSec}`}>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Email Campaign</li>
                            <li className={`${styles.breadcrumbItem}`}><Link to={"/communication/campaigns"}>Manage Campaign</Link></li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>{isAddMode ? "Add Email Template" : "Edit Email Template"}</li>
                        </ol>
                    </nav>
                    <div className={`${styles.PageTitleSec}`}>
                        <div>
                            <Link to={`/communication/campaigns`} className={`${styles.BackArrow}`}><ArrowLeft /></Link>
                            <Typography display="inline" className={`${styles.pageTitle}`}>{((isAddMode) ? 'New Email Template' : 'Update Email Template')}</Typography>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit(isAddMode ? onSubmit : onUpdate)}>
                    <div className={`${styles.EmailTemplateBodySec}`}>
                        <div className={`${styles.AddLeaseSection}`}>
                            <div className={`${styles.AddDocTitleSec}`}>
                                <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                    <Controller
                                        name="title"
                                        control={control}
                                        render={(field) => (
                                            <TextField
                                                {...field}
                                                id="outlined-basic"
                                                variant="outlined"
                                                label="Title*"
                                                inputProps={{ maxLength: 200 }}
                                            />
                                        )}
                                    />
                                    {errors.title && (<p className={`${styles.ErrorM}`}>{errors.title.message}</p>)}
                                </div>
                            </div>
                            <div className={`${styles.AddDocTitleSec}`}>
                                <div className={`${styles.FormGroupAddLease} FormGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Logo Type</InputLabel>
                                        <Controller
                                            name="logo_type"
                                            control={control}
                                            render={(field) => (
                                                <Select
                                                    {...field}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Logo Type"
                                                >
                                                    <MenuItem value="PropertyDek">PropertyDek</MenuItem>
                                                    <MenuItem value="Weston Hall">Weston Hall</MenuItem>
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                            <div className={`${styles.FormGroupTextareaFull}`}>
                                <label className={`${styles.FilterLabel}`}>Description<span className={`${styles.errorSpan}`}>*</span></label>
                                <Controller
                                    name="description"
                                    control={control}
                                    render={(field) => (
                                        <Editor
                                            onInit={(evt, editor) => { editorRef.current = editor }}
                                            className={`${styles.formControlTextArea}`}
                                            apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                                            value={field?.value}
                                            init={{
                                                height: 500,
                                                menubar: false,
                                                plugins: ["lists", "code", "table", "media", "image"],
                                                toolbar: [
                                                    "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor removeformat | alignleft aligncenter alignright alignjustify | numlist bullist | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | image | code",
                                                    "firstname lastname",
                                                ],
                                                font_size_formats: "10px 12px 14px 16px 18px 20px 24px 36px 48px",
                                                content_style: 'body { font-family:Helvetica,Arial,sans-serif !important; font-size:16px }',
                                                setup: (editor) => {
                                                    editor.ui.registry.addButton("firstname", {
                                                        text: "First Name",
                                                        onAction: () =>
                                                            editor.insertContent(`{{{{FirstName}}}}`),
                                                    });
                                                    editor.ui.registry.addButton("lastname", {
                                                        text: "Last Name",
                                                        onAction: () =>
                                                            editor.insertContent(`{{{{LastName}}}}`),
                                                    });
                                                },
                                                automatic_uploads: true,
                                                file_picker_types: 'image',
                                                images_upload_url: process.env.REACT_APP_USER_API_URL + "v1/campaign/email-templates/upload-image",
                                            }}
                                            onEditorChange={(e) => field.onChange(e)}
                                        />
                                    )}
                                />
                                {errors.description && (<p className={`${styles.ErrorM}`}>{errors.description.message}</p>)}
                            </div>
                            <div className={`${styles.ButtonAction}`}>
                                <button className={`${styles.CancelPopupBU}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push('/communication/campaigns'); }}>Cancel</button>
                                <button className={`${styles.SubmitPopupBU}`} type="submit">{isAddMode ? 'Add' : 'Update'}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />
        <Footer />
    </>);
}

export default withCustomAuthenticationRequired(AddCampaign, {
    onRedirecting: () => <Loader />,
});